import AuditLogsPage from "../../components/AuditLogs";
import PageTitleComponent from "../../components/PageTitle";

export default function AuditLogsScreen(){
return <div>
    <PageTitleComponent title="Audit Logs" />
    <AuditLogsPage/>
</div>
}